import { Component, OnInit } from '@angular/core';
import { ReqHSupplRespVO } from 'src/app/shared/vo/ReqHSupplRespVO';
import { ApiService } from '../../api.service';
@Component({
  selector: 'app-supplies-requested',
  templateUrl: './supplies-requested.component.html',
  styleUrls: ['./supplies-requested.component.scss']
})
export class SuppliesRequestedComponent implements OnInit {

  listSuppliesReq:ReqHSupplRespVO[];
  listTableHeader:any[] = new Array(); 

  constructor(private apiService:ApiService
    ) {

     }

  ngOnInit(): void {
    let params = {
      supplStoreId:"0000001419",
      reqStore:"0000000003",
      language:"es",
      status:"A"
    }
    this.apiService.getSuppliesRequested(JSON.parse(JSON.stringify(params))).then(
      supplies => {
          this.listSuppliesReq = supplies;
          this.generateHeader(this.listSuppliesReq);
      }
    );
  }


  calculateCustomerTotal(name) { 
    let total = 0;
    return total;
  }

  generateHeader(listSupplies:ReqHSupplRespVO[]){
    this.listTableHeader.push({field: "itemId", header:"ID"});
    this.listTableHeader.push({field: "itemName", header:"Name"});
    listSupplies.forEach(
      suppl => {
        this.listTableHeader.push({field: suppl.storeId, header:suppl.shrName});
      }
    );
    console.debug("Generate Header Before Filter");
    console.debug(this.listTableHeader);  


    let listFilter = this.listTableHeader.filter( (thing, index, self )  =>
      index === self.findIndex((t) => (
          t.field === thing.field
        )) 
    );
    this.listTableHeader = listFilter;
    this.listTableHeader.push({field: "total", header:"TOTALES"});
    this.listTableHeader.push({field: "itemName", header:"EXISTENCIA ARCOS"});

    console.debug(this.listTableHeader);
  }
}
